// IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла)
// Угол «⋯» виджета (Widget.vue): форма угла открывается так, что её «✕ Close» лежит в точке угла — клик, начатый как «клик по ⋯» сразу после наведения,
// попадал в ✕ и закрывал виджет (бой -35/-36). Защита: 1) пауза намерения наведения 350 мс (клик по углу открывает сразу, как раньше);
// 2) «взвод» — первые 300 мс после открытия формы её кнопки клик не принимают (и клик, чьё нажатие пришлось на это окно).
// Выключатель — настройка fe.ux.widgetCornerHoverArm (по умолчанию вкл; false — прежнее: пауза 50 мс, без взвода).

export const CORNER_HOVER_OPEN_MS = 350
export const CORNER_HOVER_OPEN_MS_OFF = 50
export const CORNER_ARM_MS = 300

export function cornerHoverArm_on(store) {
    try { return store?.setting?.('fe.ux.widgetCornerHoverArm', true) !== false } catch (e) { return true }
}

export function cornerHoverOpenDelay(on) { return on ? CORNER_HOVER_OPEN_MS : CORNER_HOVER_OPEN_MS_OFF }

// форма открыта в openedAt (мс); now — момент события: true — событие в окне взвода
export function cornerArmBlocks(openedAt, now, on) {
    if (!on || typeof openedAt !== 'number' || typeof now !== 'number') return false
    const d = now - openedAt
    return d >= 0 && d < CORNER_ARM_MS
}

// решение по событию формы: type — pointerdown / mousedown / mouseup / click; downBlocked — погашено ли нажатие этого клика.
// Клик, чьё нажатие погашено, гасится и после окна (нажали в окне, отпустили позже)
export function cornerArmDecide(type, openedAt, now, on, downBlocked) {
    let down = type === 'pointerdown' ? false : !!downBlocked
    if (type === 'click' && down) return { block: true, downBlocked: false }
    const block = cornerArmBlocks(openedAt, now, on)
    if (block && (type === 'pointerdown' || type === 'mousedown')) down = true
    if (type === 'click') down = false
    return { block, downBlocked: down }
}

export default { CORNER_HOVER_OPEN_MS, CORNER_HOVER_OPEN_MS_OFF, CORNER_ARM_MS, cornerHoverArm_on, cornerHoverOpenDelay, cornerArmBlocks, cornerArmDecide }
